import { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';


const PERMISSION_CONFIG = {
    task: {
        allManage: 'isAllTaskManage',
        teamManage: 'isTaskTeamManage',
        ownerLabel: 'TASK_SEARCH_OWNER'
    },
    lead: {
        allManage: 'isAllLeadManage',
        teamManage: 'isLeadTeamManage',
        ownerLabel: 'LEAD_SEARCH_OWNER'
    }
};

export const useActionablesConfig = ({ type }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const myTeam = useSelector(state => state?.owner?.Team);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    const [ownerDropdown, setOwnerDropdown] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState(null);

    const config = PERMISSION_CONFIG[type];

    const isReady = useMemo(() => {
        const hasAllManage = specificRolePermission?.[config.allManage];
        const hasTeamManage = specificRolePermission?.[config.teamManage];

        return (
            ((hasAllManage && ownerlist?.length > 0) ||
                (hasTeamManage && myTeam?.length > 0) ||
                (!(hasAllManage || hasTeamManage) && currentUser?.userId)) &&
            Object.keys(internationalise || {}).length > 0
        );
    }, [specificRolePermission, ownerlist, myTeam, currentUser, internationalise, config]);

    useEffect(() => {
        if (!isReady) return;

        const hasAllManage = specificRolePermission?.[config.allManage];
        const hasTeamManage = specificRolePermission?.[config.teamManage];

        const list = hasAllManage
            ? ownerlist
            : hasTeamManage
                ? myTeam
                : [{
                    firstName: currentUser?.firstname,
                    lastName: currentUser?.lastname,
                    id: currentUser?.userId
                }];

        const ownerListData = (list || []).map(item => ({
            name: `${item.firstName} ${item.lastName}`,
            id: item.id
        }));

        const myOrgOption = {
            name: handleValidateCodevalue(internationalise, "COMMON_ENTIRE_ORG"),
            id: "COMMON_ENTIRE_ORG"
        };
        const myTeamOption = {
            name: handleValidateCodevalue(internationalise, "COMMON_MY_TEAM"),
            id: "COMMON_MY_TEAM"
        };

        let newList = [...ownerListData];
        if (hasAllManage) newList.push(myOrgOption);
        if ((myTeam?.length > 0 && hasTeamManage) || hasAllManage) {
            newList.push(myTeamOption);
        }

        const filteredOwner = ownerListData.find(item => item.id === currentUser?.userId);
        let defaultOwner = filteredOwner;

        if (hasAllManage) {
            defaultOwner = myOrgOption;
        } else if (hasTeamManage && !hasAllManage) {
            defaultOwner = myTeamOption;
        }

        setOwnerDropdown(newList);

        setSelectedOwner(prev => {
            if (prev?.id === defaultOwner?.id) {
                return prev;
            }
            return defaultOwner;
        });

    }, [isReady, specificRolePermission, ownerlist, myTeam, currentUser, internationalise, config]);

    const handleSelectOwner = useCallback((event, owner) => {
        setSelectedOwner(owner);
    }, []);

    const isDropdownDisabled = useMemo(() => {
        const hasAllManage = specificRolePermission?.[config.allManage];
        const hasTeamManage = specificRolePermission?.[config.teamManage];
        return !(hasAllManage || hasTeamManage);
    }, [specificRolePermission, config]);

    return {
        ownerDropdown,
        selectedOwner,
        setSelectedOwner,
        handleSelectOwner,
        isDropdownDisabled,
        isReady,
        ownerLabel: config.ownerLabel,
        ownerlist,
        myTeam,
        internationalise,
        specificRolePermission
    };
};

export default useActionablesConfig;
